import { ComponentType } from "react";

import { SvgHome, SvgTicket, SvgMenu, SvgGoFlight, SvgAirplaneTakeoff } from "../Icon/icons";
import { UserContexts } from "~/application/types";
import SvgOrderApprove from "../Icon/icons/OrderApprove";

export type TabItemConfig = {
  label: string;
  value: string;
  to: string;
  icon: ComponentType;
  match?: RegExp;
  shouldShow?: (contexts: UserContexts) => boolean;
};

export type TabConfig = {
  label: string;
  value: string;
  to: string;
  icon: ComponentType;
  match?: RegExp;
  shouldShow?: (contexts: UserContexts) => boolean;
  usePopover?: (contexts: UserContexts) => boolean;
  menuItems?: TabItemConfig[];
};

export const MENU_OPTIONS: TabItemConfig[] = [
  {
    label: "Pedidos da agência",
    value: "agency-orders",
    to: "/agencias/pedidos?orderType=travel#all",
    icon: SvgTicket,
    match: /^\/agencias\/pedidos/,
    shouldShow: (ctx) => !!ctx?.agency?.uuid,
  },
  {
    label: "Meus pedidos",
    value: "my-orders",
    to: "/pedidos/meus-pedidos",
    icon: SvgTicket,
    match: /^\/pedidos\/meus-pedidos/,
    shouldShow: (ctx) => !!ctx?.customer?.uuid,
  },
];

export const TABS_CONFIG: TabConfig[] = [
  {
    label: "Início",
    value: "inicio",
    icon: SvgHome,
    to: "/busca",
    match: /^\/$/,
    shouldShow: (ctx) => !!ctx?.customer?.uuid,
  },
  {
    label: "Viagens",
    value: "travels",
    icon: SvgAirplaneTakeoff,
    to: "/busca/passagens-aereas#booking",
    match: /^\/busca\/passagens-aereas(?:#.*)?$/,
    shouldShow: (ctx) => !!ctx?.customer?.uuid,
  },
  {
    label: "Pedidos",
    value: "orders",
    icon: SvgTicket,
    to: "/pedidos/meus-pedidos?orderType=travel#all",
    match: /^\/pedidos|^\/agencias\/pedidos/,
    shouldShow: (ctx) => !!ctx?.customer?.uuid || !!ctx?.agency?.uuid,
    usePopover: (ctx) => !!ctx?.customer?.uuid && !!ctx?.agency?.uuid,
    menuItems: MENU_OPTIONS,
  },
  {
    label: "Despesas",
    value: "expenses",
    icon: SvgOrderApprove,
    to: "/despesas/inicio",
    match: /^\/despesas(\/|$)/,
    shouldShow: () => true,
  },
  {
    label: "Opções",
    value: "menu",
    icon: SvgMenu,
    to: "/menu-opcoes",
    shouldShow: () => true,
  },
];
